import React from 'react';

const ResultMatter = () => {
    return (
        <div className="section-py dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-10 lg:col-start-2 pb-[30px]">
                        <h2 className="text-primary mb-2.5" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Choose Moweb
                        </h2>
                        <p className="fw-400 mb-0 fs-md fs-mdlg" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            With 2 decades of delivery excellence, Moweb combines deep domain expertise, disciplined engineering,
                            and practical AI to help organizations transform with confidence.
                        </p>
                        <p className="fw-400 mb-0 fs-md fs-mdlg" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            Our approach is simple:
                            <br /> listen deeply, plan thoroughly, solve intelligently, deliver reliably.
                        </p>
                        <p className="fw-400 mb-0 fs-md fs-mdlg" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            We bring clarity, speed, and precision to every project - from enterprise platforms to AI-powered
                            products. With secure processes, global experience, and a culture of ownership, we ensure that every
                            solution is not only well-built but future-ready.
                        </p>
                    </div>
                </div>
                <div className="">
                    <h2
                        className="text-primary text-xl mb-5 text-center"
                        data-aos="fade-up"
                        data-aos-duration="700"
                        data-aos-delay="100"
                    >
                        At Moweb, your success is our benchmark.
                    </h2>
                    <div className="flex sm:gap-[7px] md:gap-[25px] justify-center">
                        <img
                            src="/img/logo-iso.svg"
                            alt="project image"
                            width={85}
                            height={85}
                            className="sm:w-[60px] sm:h-[60px] md:w-[80px] md:h-[80px]"
                            loading="lazy"
                        />
                        <img
                            src="/img/logo-cmmi.svg"
                            alt="project image"
                            width={85}
                            height={85}
                            className="sm:w-[60px] sm:h-[60px] md:w-[80px] md:h-[80px]"
                            loading="lazy"
                        />

                        <img
                            src="/img/logo-industry.svg"
                            alt="project image"
                            className="sm:w-[70px] sm:h-[70px] md:w-[132px] md:h-[72px]"
                            loading="lazy"
                        />
                        <img
                            src="/img/logo-projects.svg"
                            alt="project image"
                            className="sm:w-[70px] sm:h-[70px] md:w-[132px] md:h-[72px]"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultMatter;
